(function(){
  var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
  var fmt=new Intl.NumberFormat('en-US',{style:'currency',currency:cur});
  function money(c){return fmt.format(c/100);}
  function $(s,r){return (r||document).querySelector(s);}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
  function addToCart(items,btn,msg){
    if(btn)btn.classList.add('is-load');
    if(msg)msg.textContent='';
    return fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};});})
      .then(function(x){
        if(!x.ok){if(msg)msg.textContent=x.d.description||x.d.message||'Could not add to cart.';return;}
        document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
      })
      .catch(function(){window.location.href='/cart';})
      .then(function(){if(btn)btn.classList.remove('is-load');});
  }
  function initProduct(root){
    var form=$('.zp-form',root);if(!form)return;
    var variants=JSON.parse($('[data-zp-variants]',root).textContent);
    var idIn=$('[data-zp-id]',root),qtyIn=$('[data-zp-qty]',root),qtyOut=$('[data-zp-qtyout]',root);
    var atc=$('.zp-atc',root),msg=$('.zp-msg',root);
    var tiers=$$('.zp-tier',root);
    var disc=tiers.map(function(t){return +t.dataset.off||0;});
    var lowAt=+root.dataset.low||0;
    var opts=$$('.zp-opt',root);
    var selected=variants[0].options.slice();
    var startId=+idIn.value;
    variants.forEach(function(v){if(v.id===startId)selected=v.options.slice();});
    var qty=Math.max(1,+qtyIn.value||1);
    var first=true;
    function current(){return variants.filter(function(v){return v.options.join('|')===selected.join('|');})[0];}
    function setQty(n){
      qty=Math.max(1,Math.min(99,n));qtyIn.value=qty;if(qtyOut)qtyOut.textContent=qty;
      var ti=Math.min(qty,tiers.length)-1;
      tiers.forEach(function(t,i){t.classList.toggle('on',i===ti);t.setAttribute('aria-pressed',i===ti);});
      render();
    }
    function goMedia(id){
      var g=$('media-gallery',root);
      if(!id||!g)return;
      var el=g.querySelector('.m-product-media--item[data-media-id="'+id+'"]:not(.swiper-slide-duplicate)');
      if(!el)return;
      var idx=+el.dataset.index||0;
      if(g.slider&&typeof g.slider==='object'){try{g.slider.slideToLoop(idx);}catch(e){g.slider.slideTo(idx);}}
      else{el.scrollIntoView({behavior:'smooth',block:'nearest'});}
    }
    function render(){
      var v=current();
      var price=$('[data-zp-price]',root),cmp=$('[data-zp-compare]',root),save=$('[data-zp-save]',root),st=$('[data-zp-stock]',root);
      if(!v){atc.disabled=true;atc.textContent='Unavailable';if(st){st.className='zp-instock out';st.textContent='Unavailable';}return;}
      idIn.value=v.id;idIn.dispatchEvent(new Event('change',{bubbles:true}));
      document.dispatchEvent(new CustomEvent('zp:variant',{detail:{id:v.id,price:v.price}}));
      if(price)price.textContent=money(v.price);
      var has=v.compare>v.price;
      if(cmp){cmp.hidden=!has;cmp.textContent=has?money(v.compare):'';}
      if(save){save.hidden=!has;save.textContent=has?(root.dataset.saveWord||'Save')+' '+money(v.compare-v.price):'';}
      if(st){
        if(!v.available){st.className='zp-instock out';st.textContent=root.dataset.soldout||'Sold out';}
        else if(lowAt&&!v.cont&&v.inv&&v.qty>0&&v.qty<=lowAt){st.className='zp-instock low';st.textContent=(root.dataset.onlyLeft||'Only {n} left').replace('{n}',v.qty);}
        else{st.className='zp-instock';st.textContent=root.dataset.instock||'In stock';}
      }
      atc.disabled=!v.available;
      atc.textContent=v.available?(root.dataset.atc||'Add to cart'):(root.dataset.soldout||'Sold out');
      tiers.forEach(function(t,i){
        var n=i+1,base=v.price*n,off=Math.round(base*disc[i]/100);
        var pr=$('.pr',t);if(!pr)return;
        pr.innerHTML=(off>0?'<s>'+money(base)+'</s>':'')+money(base-off);
      });
      var sp=$('[data-zp-sticky-price]');if(sp)sp.textContent=money(v.price);
      if(first){first=false;}else{goMedia(v.media);var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);}
    }
    opts.forEach(function(o){
      $$('.zp-pill',o).forEach(function(p){p.addEventListener('click',function(){
        selected[+o.dataset.pos]=p.dataset.value;
        $$('.zp-pill',o).forEach(function(x){x.classList.toggle('on',x===p);x.setAttribute('aria-pressed',x===p);});
        var lab=$('[data-zp-optval]',o);if(lab)lab.textContent=p.dataset.value;
        render();
      });});
    });
    tiers.forEach(function(t,i){t.addEventListener('click',function(){setQty(i+1);});});
    $$('[data-zp-minus]',root).forEach(function(b){b.addEventListener('click',function(){setQty(qty-1);});});
    $$('[data-zp-plus]',root).forEach(function(b){b.addEventListener('click',function(){setQty(qty+1);});});
    form.addEventListener('submit',function(e){
      e.preventDefault();var v=current();if(!v||!v.available)return;
      addToCart([{id:v.id,quantity:qty}],atc,msg);
    });
    var sticky=$('.zp-sticky',root);
    if(sticky&&'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(en){en.forEach(function(e){sticky.classList.toggle('show',!e.isIntersecting&&e.boundingClientRect.top<0);});});
      io.observe(atc);
      var sb=$('.zp-btn',sticky);if(sb)sb.addEventListener('click',function(){if(form.requestSubmit)form.requestSubmit();else atc.click();});
    }
    var dl=$('[data-zp-dl]',root);
    if(dl){
      var days=+dl.dataset.days||8,cut=+dl.dataset.cutoff;if(isNaN(cut))cut=17;
      var out=$('[data-zp-date]',dl),cd=$('[data-zp-cd]',dl);
      var tickd=function(){
        var now=new Date(),c=new Date(now);c.setHours(cut,0,0,0);
        var after=now>=c;if(after)c.setDate(c.getDate()+1);
        var d=new Date(now);d.setDate(d.getDate()+days+(after?1:0));
        if(out)out.textContent=d.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'});
        var ms=c-now,h=Math.floor(ms/36e5),m=Math.floor(ms%36e5/6e4);
        if(cd)cd.textContent=(h<10?'0':'')+h+'h '+(m<10?'0':'')+m+'m';
      };
      tickd();setInterval(tickd,30000);
    }
    setQty(qty);
  }
  function initBundle(root){
    var rows=$$('.zp-row',root),btn=$('.zp-btn',root),msg=$('.zp-msg',root);
    var off=+root.dataset.off||0,mq=+root.dataset.min||2;
    function calc(){
      var sel=rows.filter(function(r){return $('input',r).checked;});
      var sum=sel.reduce(function(a,r){return a+ +r.dataset.price;},0);
      var apply=sel.length>=mq&&off>0,disc=apply?Math.round(sum*off/100):0;
      $('[data-zp-bsum]',root).innerHTML=(apply?'<s>'+money(sum)+'</s> ':'')+money(sum-disc);
      $('[data-zp-bnote]',root).textContent=apply?(root.dataset.save||'You save')+' '+money(disc):'';
      btn.textContent=(root.dataset.btn||'Add {n} to cart').replace('{n}',sel.length);
      btn.disabled=!sel.length;root._items=sel.map(function(r){return {id:+r.dataset.id,quantity:1};});
    }
    rows.forEach(function(r){$('input',r).addEventListener('change',calc);});
    document.addEventListener('zp:variant',function(e){
      var m=rows[0];if(!m||!m.dataset.main)return;
      m.dataset.id=e.detail.id;m.dataset.price=e.detail.price;
      var pr=$('.pr',m);if(pr)pr.textContent=money(e.detail.price);
      calc();
    });
    btn.addEventListener('click',function(){var it=root._items||[];if(it.length)addToCart(it,btn,msg);});
    calc();
  }
  function init(){
    $$('[data-zp]').forEach(function(r){if(!r._zp){r._zp=1;initProduct(r);}});
    $$('[data-zp-bn]').forEach(function(r){if(!r._zp){r._zp=1;initBundle(r);}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();